<template>
    <span>{{tweeningValue }}</span>
</template>
<script>
export default {
    props: {
        value: {
            type: Number,
            required: true
        },
        time: {
            type: Number,
            default: 1000
        }
    },
    data () {
        return {
            tweeningValue: 0
        }
    },
    watch: {
        value: function (newValue, oldValue) {
            if(TWEEN) {
                this.tween(oldValue, newValue)
            }else{
                this.tweeningValue = newValue
            }
            
        }
    },
    mounted: function () {
        this.tween(0, this.value)
    },
    methods: {
        tween: function (startValue, endValue) {
        var vm = this
        function animate () {
            if (TWEEN.update()) {
            requestAnimationFrame(animate)
            }
        }

        new TWEEN.Tween({ tweeningValue: startValue })
            .to({ tweeningValue: endValue }, this.time)
            .onUpdate(function () {
            vm.tweeningValue = this.tweeningValue.toFixed(0)
            })
            .start()

        animate()
        }
    }
}
</script>
